module.exports = __webpack_public_path__ + "octoclippy.c6dd91f704d3e626b4f262534a870dcd.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/layout/octoclippy.png
// module id = 1231
// module chunks = 1